var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimesDanger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uq-admin-site-settings",
    transform: "translate(-881.000000, -1155.000000)",
    fill: "#F36969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "section",
    transform: "translate(360.000000, 774.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "col-1",
    transform: "translate(447.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-remove",
    transform: "translate(74.000000, 286.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C19.9838673,4.48384871 15.5161513,0.0161327135 10,0 Z M14.63375,13.75 L13.75,14.63375 L10,10.88375 L6.25,14.63375 L5.36625,13.75 L9.11625,10 L5.36625,6.25 L6.25,5.36625 L10,9.11625 L13.75,5.36625 L14.63375,6.25 L10.88375,10 L14.63375,13.75 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesDanger);
export default __webpack_public_path__ + "static/media/times-danger.afba92968105fd247bb67d99f078f72f.svg";
export { ForwardRef as ReactComponent };